<template>
  <div>
    <v-btn @click="onClick" color="primary" class="mr-4" dark>
      <v-icon>add</v-icon>新規登録
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'IntervalReportButtonAdd',
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style></style>
